import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dataAuditTrail: [],
  keyword: {
    auditTrail: ""
  },
  loading: false,
  sortConfig: {
    key: "createdAt",
    direction: "DESC",
  },
};

export const AuditTrail = createSlice({
  name: "audit_trail",
  initialState,
  reducers: {
    ChangeDataAuditTrail: (state, action) => {
      state.dataAuditTrail = action.payload;
    },
    ChangeKeyword: (state, action) => {
      const { menu, value } = action.payload;
      state.keyword[menu] = value;
    },
    ChangeLoading: (state, action) => {
      state.loading = action.payload;
    },
    ChangeSortConfig: (state, action) => {
      state.sortConfig = action.payload;
    },
  },
});

export const {
  ChangeDataAuditTrail,
  ChangeKeyword,
  ChangeLoading,
  ChangeSortConfig,
} = AuditTrail.actions;

export default AuditTrail.reducer;